"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckboxesField = _interopRequireDefault(require("./CheckboxesField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const CheckboxesWidget = (_ref) => {
  let id = _ref.id,
      disabled = _ref.disabled,
      options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      autofocus = _ref.autofocus,
      readonly = _ref.readonly,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "disabled", "options", "value", "autofocus", "readonly", "onChange"]);

  const enumOptions = options.enumOptions,
        enumDisabled = options.enumDisabled,
        inline = options.inline;
  const label = options.title || props.title || props.label || "bool";
  const checkboxOptions = enumOptions.map((option, index) => {
    const itemId = id + "_" + index;
    const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    const checked = value.indexOf(option.value) !== -1;
    return {
      id: itemId,
      label: option.label,
      value: option.value,
      disabled: disabled || itemDisabled || readonly,
      checked: checked
    };
  });
  return _react.default.createElement(_CheckboxesField.default, {
    id: id,
    label: label,
    options: checkboxOptions,
    value: value,
    onChange: onChange
  });
};

CheckboxesWidget.defaultProps = {
  autofocus: false,
  options: {
    inline: false
  }
};
CheckboxesWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: _propTypes.default.object.isRequired,
  id: _propTypes.default.string.isRequired,
  options: _propTypes.default.shape({
    enumOptions: _propTypes.default.array,
    inline: _propTypes.default.bool
  }).isRequired,
  value: _propTypes.default.any,
  required: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  autofocus: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : {};
var _default = CheckboxesWidget;
exports.default = _default;
module.exports = exports.default;